import React from "react";
import { Grid, Box } from "@mui/material";

interface FormGridProps {
  fields: {
    label: string;
    component: React.ReactNode;
  }[];
  fullWidth?: boolean; // Optional prop to control width
}

export const FormGrid: React.FC<FormGridProps> = ({
  fields,
  fullWidth = false,
}) => (
  <Grid container spacing={2}>
    {fields.map((field, index) => (
      <Grid
        item
        xs={12}
        sm={fullWidth ? 12 : 6}
        md={fullWidth ? 12 : 6}
        key={index}
      >
        <label className="text-lable">{field.label}</label>
        <Box sx={{ width: "100%" }}>{field.component}</Box>
      </Grid>
    ))}
  </Grid>
);
